export enum BandwidthStatusEnum {
  Online = 'online',
  Unstable = 'unstable',
  Offline = 'offline',
}

export type BandwidthContextType = {
  status: BandwidthStatusEnum;
  setStatus: (status: BandwidthStatusEnum) => void;
};
